import { Button } from '@mantine/core';
import { ComponentProps } from 'react';
import styles from './styles.module.css';

type CompactButtonProps<C = 'button'> = ComponentProps<typeof Button<C>>;

export const CompactButton = (props: CompactButtonProps) => (
	<Button variant="transparent" color="black" p="0" {...props} className={styles.button} />
);
